export default function AirplaneIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3334 13.3337V11.667L11.2501 7.50033V2.91699C11.2501 2.22533 10.6917 1.66699 10.0001 1.66699C9.30841 1.66699 8.75008 2.22533 8.75008 2.91699V7.50033L1.66675 11.667V13.3337L8.75008 11.2503V15.8337L6.66675 17.0837V18.3337L10.0001 17.5003L13.3334 18.3337V17.0837L11.2501 15.8337V11.2503L18.3334 13.3337Z"
        fill="#323232"
      />
    </svg>
  );
}
